import { MappedProject, ProjectsByYear } from "../types/new/project";

export const getFilter = (architecture: string, ecosysteme: string) => {
  if (architecture) {
    return `architecture=${architecture}`;
  }
  if (ecosysteme) {
    return `ecosysteme=${ecosysteme}`;
  }
  return "";
};

export const filterProjects = (
  projects: MappedProject[],
  architecture: string,
  ecosysteme: string
) => {
  return projects.filter((project) => {
    if (
      architecture &&
      !project.architectureThemes?.some((theme) => theme.slug === architecture)
    ) {
      return false;
    }
    if (
      ecosysteme &&
      !project.ecosystemeThemes?.some((theme) => theme.slug === ecosysteme)
    ) {
      return false;
    }
    return true;
  });
};

export function groupProjectsByYear(projects: MappedProject[]): ProjectsByYear {
  const sortedProjects = [...projects].sort(
    (a, b) => Number(b.year) - Number(a.year)
  );

  // Reduce the sorted projects into an object grouped by year
  return sortedProjects.reduce((acc: ProjectsByYear, project) => {
    const year = project.year;

    const currentYear = new Date().getFullYear();

    const key = +year > currentYear ? "En cours" : year;

    if (!acc[key]) {
      acc[key] = [];
    }

    acc[key].push(project);
    return acc;
  }, {});
}
